import { useEffect, useState } from "react";
import CashRegisterService from "../../services/cashRegisterService";

//Hooks
import useUser from "../user/useUser";
import useNotify from '../notify';

const useMonthlyImprest = ( branchId ) => {
    const { branch } = useUser();
    const [monthlyImprest, setMonthlyImprest] = useState();
    const [loading, setLoading] = useState(false);
    const { Notify, variants } = useNotify();

    useEffect(() => {
        const getMonthlyImprest = () => {
            setLoading(true);
            CashRegisterService
                .GetMonthlyImprest(branchId || branch?.id)
                .then(res => {
                    setMonthlyImprest({
                        ...res,
                        totalAmountImprest: res.movementTotals?.find(e => e.movementSubTypes === "Imprest")?.total || 0
                    });
                })
                .catch((err) => Notify(err.message, variants.ERROR))
                .finally(() => setLoading(false))
        }

        if (branchId || (branch && branch.id && branch.id !== 0))
            getMonthlyImprest(branchId);
    }, [branchId, branch, Notify, variants.ERROR]);

    return {
        monthlyImprest,
        loading,
    };
};

export default useMonthlyImprest;